import { Component, OnInit, ElementRef, TemplateRef, ChangeDetectorRef, ViewChild, Input, Inject, SimpleChanges, SimpleChange, AfterViewInit  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IPostMessageEventTarget, PostMessageBridgeFactory } from 'ngx-post-message/ngx-post-message';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { combineLatest, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Preferences } from '../models/settings';

@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})

export class IframeComponent implements OnInit, AfterViewInit {
  @Input() srcInput: string;
  @Input() redirectURL: string;
  @Input() restURL: string;
  @Input() domain: string;
  @Input() params: Preferences;
  @ViewChild('iframe') iframe: ElementRef;
  @ViewChild('template') template : TemplateRef<any>;

  language: string = "";

  showIframe: boolean = false;
  showError: boolean = false;

  iFrame: IPostMessageEventTarget = window.frames[0];

  modalRef: BsModalRef;
  openModalFlag = false;
  subscriptions: Subscription[] = [];

  continue: string;
  successTitle: string;
  success: string;
  errorTitle: string;
  error: string;
  abortTitle: string;

  finalModalTitleText = '';
  finalModalText = '';
  response: string = '';
  responseCode: string = '';
  modalIcon = faCheckCircle;
  backgroundColor = 'bg-success';
  finalModalTextSize = '';

  arrowIcon = faArrowRight;


  constructor( private translateService: TranslateService, private route: ActivatedRoute, private modalService: BsModalService, private changeDetection: ChangeDetectorRef) {  }

  ngOnInit() {
    this.language = this.translateService.currentLang

    this.translateService.get(["SUCCESS-TITLE", "SUCCESS", "ERROR-TITLE", "ERROR", "ABORT-TITLE","CONTINUE"]).subscribe(response =>{
      this.successTitle = response['SUCCESS-TITLE'];
      this.success = response.SUCCESS;
      this.errorTitle = response['ERROR-TITLE'];
      this.error = response.ERROR;
      this.abortTitle = response['ABORT-TITLE'];
      this.continue = response.CONTINUE;
    })

    if(this.route.snapshot.queryParamMap.get("token") &&
      this.route.snapshot.queryParamMap.get("domain") &&
      this.domain != 'DEFAULT'){
      this.handleEvents();
      this.showIframe = true;
    } else {
      this.showIframe = false;
    }

    if(this.route.snapshot.queryParamMap.get("domain") == 'DEFAULT'){
      this.showError = false;
    } else {
      this.showError = true;
    }
  }

  ngAfterViewInit() {
    if (this.srcInput && this.showIframe) {
      this.iframe.nativeElement.src = this.srcInput;
    }
  }

  private handleEvents() {
    this.bindEvent(window, 'message',  (e) => {
      console.log("Received Message from DoCheck - Type: " + e.data.t + " Reason: " + e.data.m);
      let messageJson = JSON.stringify(e.data);
      if (e.data.t == "orchestrator_finished") {
        this.response = 'COMPLETED';
        this.responseCode = 'OK';
        this.modalIcon = faCheckCircle;
        this.backgroundColor = 'bg-success';
        if(this.domain == 'EUROVITA_SELFID' && this.language == 'it'){
          this.finalModalTextSize = 'eurovita-text'
        }
        if(this.domain == 'CRONOSVITA_SELFID' && this.language == 'it'){
          this.finalModalTextSize = 'cronosvita-text'
        }
        this.finalModalTitleText = this.successTitle;
        this.finalModalText = this.success;
        //this.redirectOnConfirmation()
        this.showIframe = false;
        this.showError = false;
        if(!this.openModalFlag){
          this.openModalFlag = true
          this.openModal();
        }
      } if(e.data.t === 'orchestrator_ready') {
        let _uuid: string = this.route.snapshot.queryParamMap.get("token");
        let _domain: string = this.route.snapshot.queryParamMap.get("domain");

        const _enableProgressBarOnTop = this.params.progressBarVisibile;
        window.frames[0].postMessage({
          "t": "start_orchestrator", "m": {
            "uuid": _uuid, "domain": _domain, 'enableProgressBarOnTop': _enableProgressBarOnTop, "restUrl": this.restURL, "language": this.language
          }
        }, '*');
      } else if (e.data.t == "orchestrator_error" && e.data.x == "") {
        this.response = 'COMPLETED';
        this.responseCode = 'KO';
        this.modalIcon = faTimesCircle;
        this.backgroundColor = 'bg-danger';
        this.finalModalTitleText = this.errorTitle;
        this.finalModalText = this.error;
        this.showIframe = false;
        this.showError = false;
        if(!this.openModalFlag){
          this.openModalFlag = true
          this.openModal();
        }

      } else if (e.data.t == "orchestrator_aborted" && e.data.x == "finished") {
        this.response = 'COMPLETED';
        this.responseCode = 'KO';
        this.modalIcon = faTimesCircle;
        this.backgroundColor = 'bg-danger';
        this.finalModalTitleText = this.abortTitle;
        this.finalModalText = this.error;
        this.showIframe = false;
        this.showError = false;
        if(!this.openModalFlag){
          this.openModalFlag = true
          this.openModal();
        }

      } else {
        console.log("Received Message from DoCheck: " + messageJson);
      }
    });
  }

  bindEvent(element, eventName, eventHandler) {
    if (element.addEventListener) {
      element.addEventListener(eventName, eventHandler, false);
    } else if (element.attachEvent) {
      element.attachEvent('on' + eventName, eventHandler);
    }
  }

  openModal() {
    const _combine = combineLatest(
      this.modalService.onHide,
      this.modalService.onHidden
    ).subscribe(() => this.changeDetection.markForCheck());

    this.subscriptions.push(
      this.modalService.onHide.subscribe((reason: string) => {
        this.redirectOnConfirmation()
        this.unsubscribe();
      })
    );
    this.subscriptions.push(
      this.modalService.onHidden.subscribe((reason: string) => {
        this.redirectOnConfirmation()
        this.unsubscribe();
      })
    );

    this.modalRef = this.modalService.show(this.template, { class: 'border-0' });
  }

  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  redirectOnConfirmation() {
    if(this.response && this.responseCode) {
      this.redirectURL += `?response=${this.response}&code=${this.responseCode}`;
    }
    window.location.href = this.redirectURL;
  }

}
